package app.nestbridge.feature.designcatalog.presentation

import androidx.compose.runtime.Composable
import com.karawek.core.network.AuthMode
import app.nestbridge.app.screen.AppScreen
import app.nestbridge.feature.designcatalog.screen.DesignCatalogEvent
import app.nestbridge.feature.designcatalog.screen.DesignCatalogScreen
import app.nestbridge.feature.designcatalog.screen.DesignCatalogState
import app.nestbridge.feature.profile.screen.ProfileEvent
import app.nestbridge.feature.profile.screen.ProfileState
import com.slack.circuit.codegen.annotations.CircuitInject
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import kotlinx.coroutines.launch
import me.tatarka.inject.annotations.Assisted
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(
    screen = DesignCatalogScreen::class,
    scope = AppScope::class,
)
class DesignCatalogPresenter @Inject constructor(
    @Assisted private val navigator: Navigator,
) : Presenter<DesignCatalogState> {

    @Composable
    override fun present(): DesignCatalogState {
        fun handleEvent(event: DesignCatalogEvent) {
            when (event) {
                DesignCatalogEvent.BackClicked -> navigator.pop()
            }
        }

        return DesignCatalogState(
            eventSink = ::handleEvent,
        )
    }
}
